const metaEnv = import.meta.env;
const mode = metaEnv.MODE;

export const BASE_URL = metaEnv.VITE_BASE_URL;
export const API_URL = metaEnv.VITE_API_URL;
export const SENTRY_DSN = metaEnv.VITE_SENTRY_DSN;
export const SENTRY_ENV = metaEnv.VITE_SENTRY_ENV;
export const SENTRY_ORG = metaEnv.VITE_SENTRY_ORG;
export const SENTRY_PROJECT = metaEnv.VITE_SENTRY_PROJECT;
export const SENTRY_AUTH_TOKEN = metaEnv.VITE_SENTRY_AUTH_TOKEN;
export const MIXPANEL_TOKEN = metaEnv.VITE_MIXPANEL_TOKEN;
export const RELEASE_VERSION = metaEnv.VITE_RELEASE_VERSION;
export const PAYABLI_SCRIPT_URL =
  mode === "production"
    ? "https://embedded-component.payabli.com/"
    : "https://embedded-component-sandbox.payabli.com/";
// Fallback used only when an org has no payment links to read the portal home
// URL from. No dedicated portal base URL is otherwise configured in this repo.
export const PORTAL_BASE_URL =
  metaEnv.VITE_PORTAL_BASE_URL ?? "https://portal-staging.thefuturesapp.com";
